/* global $ */

class Categories {
  constructor(options = {}) {
    this.config = {
      module: document.querySelector('[data-module="Categories"]'),
      mobileBreakpoint: 768,
      ...options
    };
  }

  init() {
    const { module, mobileBreakpoint } = this.config;

    if (!module) {
      return;
    }

    const allCategoriesTrigger = module.querySelector('[href="#allCategories"]');
    const allCategories = module.querySelector('#allCategories');

    if (allCategoriesTrigger && allCategories) {
      $(allCategories).collapse(window.innerWidth < mobileBreakpoint ? 'hide' : 'show');
      allCategoriesTrigger.classList.remove('hidden');
      allCategories.classList.remove('hidden');
    }
  }
}

export default Categories;
